// extracted by mini-css-extract-plugin
module.exports = {"root":"Button-root-pIysd","default":"Button-default-1tvn-","round":"Button-round-H+Rld","primary":"Button-primary-SEVj6","secondary":"Button-secondary-V82xI"};